    <organization-select    #orgManager
                            class           =   "mr-3"
                            autoSelectFirst =   "true"> </organization-select>                        

    <site-select            #siteManager
                            [org]           =   "orgManager?.currentValue"
                            autoSelectFirst =   "true"
                            class           =   "mr-3"
                            (change)        =   "setSite($event)"> </site-select>
                            
    <device-select          #deviceManager
                            [site]          =   "siteManager?.currentValue"
                            autoSelectFirst =   "true"
                            class           =   "mr-3"
                            type            =   "40"
                            (change)        =   "setDevice($event)"> </device-select>

    <br>
                            
    <help-alert
        info        = "help.info"
        action      = "help.page.time_device.action"
        description = "help.page.time_device.description">
    </help-alert>

    <br>
    <br>

    <custom-table           [hidden]="values == undefined || values == null"
                            #deviceTimeTable
                            table_id            =   "deviceTimeTable"
                            title_single        =   "tables.time.device.title_single"
                            title_multiple      =   "tables.time.device.title"
                            filter_title        =   "tables.time.device.filter_title"
                            no_filter_row       =   "true"
                            [columns]           =   "timeServiceColumns"
                            [values]            =   "values"
                            [parent]            =   "this"
                            [create]            =   "true"
                            [update]            =   "false"
                            [delete]            =   "true"
                            [buttons]           =   "buttons"></custom-table>